import React, { createContext, useState, useContext } from 'react';
// Create a context
export const MyContext = createContext();

// Create a provider component
export const ProviderContext = ({ children }) => {
  const [menuComponent, setMenuComponent] = useState({home:'',about:'', services:'',team:'',contact:'',project:''});
  
  return (
    <MyContext.Provider value={{ menuComponent, setMenuComponent }}>
      {children}
    </MyContext.Provider>
  );
};

